import Plyr from 'plyr'
import Flickity from 'flickity'
import MicroModal from 'micromodal'
import { $, each, getAjax, getSreenSizes, paginateArray } from '../util'

const VideoManager = (() => {
  const play = () => {
    const container = $('.js-player-container')
    let playerInstances = Plyr.setup('.js-video-player', {
      controls: [
        'play-large',
        'restart',
        'play',
        'progress',
        'current-time',
        'duration',
        'mute',
        'volume',
        'fullscreen',
      ],
      settings: [
        'speed',
        'loop',
      ],
    })

    each(container, (i, ct) => {
      const relativeSlider = ct.querySelector('.js-video-relative')
      const slides = ct.querySelectorAll('.js-video-relative-slide')
      const search = ct.querySelector('.js-video-search')

      const relativeInstance = new Flickity(relativeSlider, {
        cellSelector: '.js-video-relative-slide:not(.u-d-none)',
        cellAlign: 'left',
        pageDots: false,
        freeScroll: true,
        prevNextButtons: false,
        wrapAround: true,
        draggable: false,
      })

      const next = ct.querySelector('.js-video-relative-next')
      if (next) {
        next.addEventListener('click', () => {
          relativeInstance.next()
        })
      }

      const prev = ct.querySelector('.js-video-relative-prev')
      if (prev) {
        prev.addEventListener('click', () => {
          relativeInstance.previous()
        })
      }

      const t = 250
      each(slides, (l, slide) => {
        const videoId = slide.dataset.videoId
        const preview = slide.querySelector('.js-video-relative-img')
        if (preview) {
          setTimeout(() => {
            getAjax('/vimeo_image/?video_id=' + videoId, (data) => {
              const res = JSON.parse(data)
              if (res.result === true) {
                preview.setAttribute('style', `background-image:url('${res.response.thumbnail_url}');`)
              }
            })
          }, t * l)
        }

        slide.addEventListener('click', function() {
          playerInstances[i].source = {
            type: 'video',
            sources: [
              {
                src: videoId,
                provider: 'vimeo',
              },
            ],
          }
        })
      })

      if (search) {
        search.addEventListener('keyup', (e) => {
          const value = e.target.value.toLowerCase()
          const s = []
          each(slides, (l, slide) => {
            const videoName = (slide.getAttribute('data-video-name') || '').toLowerCase()
            if (!videoName.includes(value) && value != '') {
              slide.classList.add('u-d-none')
            } else {
              s.push(videoName.includes(value))
              slide.classList.remove('u-d-none')
            }
          })

          relativeInstance.reloadCells()
          relativeInstance.reposition()
          relativeInstance.select(1)
        })
      }
    })
  }

  // Gestione custom player homepage con chiusura video a chiusura modale.
  const playHomeABout = () => {
    const trigger = document.querySelector('.js-video-about-home-trigger')
    const close = document.querySelector('.js-video-about-home-close')
    if (!trigger || !close) return

    const player = new Plyr('#modalAboutVideoPlayer')

    trigger.addEventListener('click', (e) => {
      e.preventDefault()

      player.play()
      MicroModal.show('modalAboutVideo', { disableScroll: true })
    })

    close.addEventListener('click', (e) => {
      console.log('esecuzione close')

      player.pause()
      MicroModal.close('modalAboutVideo')
    })
  }

  // Gestione slider di player video con load all'apertura del modale.
  const videoSliderInt = () => {
    const container = document.querySelector('.js-video-slider-int-container')
    const activators = document.querySelectorAll('.js-video-slider-int-activator')
    if (!container) return

    const containerContent = container.querySelector('.o-container')
    activators.forEach((activator) => {
      activator.addEventListener('click', (e) => {
        e.preventDefault()
        const videos = JSON.parse(activator.getAttribute('data-videos'))
        const source = activator.getAttribute('data-videos-source')
        containerContent.innerHTML = ''

        // build slider
        const slider = document.createElement('div')
        slider.classList.add('c-video-slider')
        containerContent.appendChild(slider)

        if (getSreenSizes().width > 768) {
          const slides = []
          let players = []
          // build slides
          videos.forEach((video, index) => {
            const slide = document.createElement('div')
            slide.classList.add('c-video-slider__slide')
            slide.classList.add('js-video-slider-slide')
            slider.appendChild(slide)
            slides.push(slide)

            const play = document.createElement('div')
            play.classList.add('plyr-target')
            slide.appendChild(play)

            play.setAttribute('data-plyr-provider', source)
            play.setAttribute('data-plyr-embed-id', video)

            if (index < 3) {
              const player = new Plyr(play)
              players.push(player)
            }
          })

          // build next
          const next = document.createElement('div')
          next.classList.add('c-video-slider__next')
          next.innerText = 'Next'
          slider.appendChild(next)

          // initialize slider
          const flikitySlider = new Flickity(slider, {
            cellSelector: '.js-video-slider-slide',
            cellAlign: 'left',
            pageDots: false,
            freeScroll: true,
            prevNextButtons: false,
            wrapAround: true,
            draggable: false,
          })
          next.addEventListener('click', (e) => {
            e.preventDefault()
            players.forEach((player) => player.pause())
            flikitySlider.next()
          })
          flikitySlider.on('change', (index) => {
            const loadPlayer = (container) => {
              if (!container) return

              const play = container.querySelector('.plyr-target')
              const player = new Plyr(play)
              players.push(player)
            }

            loadPlayer(slides[index + 2])
            loadPlayer(slides[index + 3])
            loadPlayer(slides[index + 4])
          })
        } else {
          const renderVideos = (page) => {
            slider.innerHTML = ''

            const pageVideos = paginateArray(videos, 3, page)
            pageVideos.forEach((video) => {
              const slide = document.createElement('div')
              slide.classList.add('c-video-slider__slide')
              slide.classList.add('js-video-slider-slide')
              slider.appendChild(slide)
  
              const play = document.createElement('div')
              slide.appendChild(play)
  
              play.setAttribute('data-plyr-provider', source)
              play.setAttribute('data-plyr-embed-id', video)
              const player = new Plyr(play)
            })
          }

          let page = 1
          renderVideos(page)

          // build next
          if (videos.length > 3) {
            const next = document.createElement('div')
            next.classList.add('c-video-slider__next')
            next.innerText = 'Next'
            slider.parentNode.appendChild(next)

            next.addEventListener('click', (e) => {
              e.preventDefault()

              page += 1
              renderVideos(page)

              if (!paginateArray(videos, 3, page + 1).length > 0) {
                next.innerHTML = 'First'
                page = 0
              } else {
                next.innerHTML = 'Next'
              }
            })
          }
        }

        // finally open modal
        MicroModal.show(container.id)
      })
    })

    // listen modal close to destroy all
    const observer = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (!mutation.target.classList.contains('is-open')) {
          containerContent.innerHTML = ''
        }
      })
    })
    observer.observe(container, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  const init = () => {
    play()
    playHomeABout()
    videoSliderInt()
  }

  return {
    init,
  }
})()

export default VideoManager



// WEBPACK FOOTER //
// app/javascript/scripts/components/VideoManager.js